//https://github.com/tappyy/react-IS4-auth-demo
import React, { useEffect, useRef } from 'react';
import { applicationState } from 'shared/store/applicationState';
import { UserManager } from 'oidc-client';
import { userMapper } from 'overrides/mapping/user-mapping'

export default function AuthProvider(props: { userManager: UserManager , children: any, onUserLoaded?: () => void }) {

    let userManager = useRef<UserManager | null>(null);

    useEffect(() => {
        userManager.current = props.userManager;

        const onUserLoaded = (oidcUser: any) => {
            if (oidcUser) {
                const user = userMapper.mapFromOIDCUser(oidcUser);
                applicationState.setUser(user);
            }
            if (props.onUserLoaded) props?.onUserLoaded();
        }

        const onUserUnloaded = () => {
            console.log(`user unloaded`);
            applicationState.setUser(undefined);
        }

        const onAccessTokenExpiring = () => {
            console.log(`user token expiring`);
            userManager?.current?.signinSilent();
        }

        const onAccessTokenExpired = () => {
            console.log(`user token expired`);
            applicationState.setUser(undefined);
            userManager?.current?.signinRedirect();
        }

        const onUserSignedOut = () => {
            console.log(`user signed out`);
            applicationState.setUser(undefined);
            userManager?.current?.signinRedirect();
        }

        const onSilentRenewError = (error: Error) => {
            console.log(`Silent renew caused an error ` + error.message);
            console.log(error);
            applicationState.setUser(undefined);
            userManager?.current?.signinRedirect();
        }

        // events for user

        if (userManager) {
            userManager?.current?.events.addUserLoaded(onUserLoaded);
            userManager?.current?.events.addUserUnloaded(onUserUnloaded);
            userManager?.current?.events.addAccessTokenExpiring(onAccessTokenExpiring);
            userManager?.current?.events.addAccessTokenExpired(onAccessTokenExpired);
            userManager?.current?.events.addUserSignedOut(onUserSignedOut);
            userManager?.current?.events.addSilentRenewError(onSilentRenewError);
        }

        // Specify how to clean up after this effect:
        return function cleanup() {
            if (userManager) {
                userManager?.current?.events.removeUserLoaded(onUserLoaded);
                userManager?.current?.events.removeUserUnloaded(onUserUnloaded);
                userManager?.current?.events.removeAccessTokenExpiring(onAccessTokenExpiring);
                userManager?.current?.events.removeAccessTokenExpired(onAccessTokenExpired);
                userManager?.current?.events.removeUserSignedOut(onUserSignedOut);
                userManager?.current?.events.removeSilentRenewError(onSilentRenewError);
            }
        };
    }, [props.userManager]);

    return (
        React.Children.only(props.children)
    )
}